import {
    LuArrowRightLeft,
    LuChartCandlestick,
    LuLock,
    LuPercent,
    LuRepeat,
    LuWaypoints,
} from "react-icons/lu";

/* The USDX Smart ecosystem. SwapX is this app, so its href is a path here
   rather than a subdomain; FutureX is still unbuilt so it stays flagged and
   unclickable. */
export function useNavItems() {
    return [
        { label: "Fixed APY", icon: LuPercent, href: "https://apy.usdx.live/" },
        {
            label: "Stable DEX",
            icon: LuArrowRightLeft,
            href: "https://dex.usdx.live/",
        },
        { label: "SwapX", icon: LuRepeat, href: "/bridge" },
        { label: "BridgeX", icon: LuWaypoints, href: "https://bridgex.usdx.live/" },
        { label: "Smart Staking", icon: LuLock, href: "https://staking.usdx.live/" },
        {
            label: "FutureX",
            icon: LuChartCandlestick,
            href: "https://future.usdx.live/",
            comingSoon: true,
        },
    ];
}

// The ecosystem apps live on separate subdomains, so the item pointing at the
// host we are currently served from is the "active" one. A bare path is a page
// of this app and is active while the current path sits under it.
export function isActiveItem(href, pathname = window.location.pathname) {
    if (href.startsWith("/")) {
        return pathname === href || pathname.startsWith(`${href}/`);
    }
    try {
        return new URL(href).hostname === window.location.hostname;
    } catch {
        return false;
    }
}
